/**
 * Which type of data table will be display
 */
export const VIEW_DATA_TYPES = {
  HISTORY: 'history', // all history of rates rates
  CURRENT: 'current', // actual rates
};
